module.exports = __webpack_public_path__ + "static/grandprize-prize-xbox-de-DE-b63128c80fbd26bb14387c641f0839d7.png";